// @flow
import React from 'react';
import { ATTRIB_TYPE_ICON_COMPONENTS } from './constants';

type Props = {
    typeEnum: number
};

export default function AttribTypeIcon({ typeEnum }: Props) {
    return ATTRIB_TYPE_ICON_COMPONENTS[typeEnum] || null;
}
